import connectProgressBarTab from './ProgressBarTabContainer';
import _ProgressBarTab from './ProgressBarTab';
import _ProgressBarPreviewMobile from './ProgressBarPreviewMobile';

export const ProgressBarTab = connectProgressBarTab(_ProgressBarTab);
export const ProgressBarPreviewMobile = connectProgressBarTab(_ProgressBarPreviewMobile);
